import { TESTIMONIALS } from "../data/site";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-20 bg-[#0B0B0B]"
    >
      <div className="max-w-7xl mx-auto">
        {/* Trust badges row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#262626] border border-[#262626] mb-16 md:mb-20 reveal">
          {[
            {
              icon: "lock",
              k: "Secure Checkout",
              l: "via Etsy — trusted by millions",
            },
            {
              icon: "globe",
              k: "Trusted Worldwide",
              l: "Customers across 20+ countries",
            },
            {
              icon: "plane",
              k: "Fast Shipping",
              l: "Dispatched from Australia",
            },
          ].map((t) => (
            <div
              key={t.k}
              data-testid={`trust-badge-${t.k.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-[#0B0B0B] p-8 md:p-10 text-center flex flex-col items-center gap-4"
            >
              <div className="w-11 h-11 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37]">
                {t.icon === "lock" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                )}
                {t.icon === "globe" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" />
                  </svg>
                )}
                {t.icon === "plane" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                  </svg>
                )}
              </div>
              <div>
                <div className="font-serif-display text-lg md:text-xl text-gold-shimmer">
                  {t.k}
                </div>
                <p className="mt-2 text-[11px] tracking-[0.28em] uppercase text-white/55">
                  {t.l}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 reveal">
          <div>
            <span className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37]">
              № 06 — Voices
            </span>
            <h2 className="mt-5 font-serif-display text-[36px] sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-white max-w-2xl">
              Loved across <span className="italic text-white/80">homes.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="w-4 h-4 text-[#D4AF37]" fill="#D4AF37" />
            ))}
            <span className="ml-2 text-[11px] tracking-[0.28em] uppercase text-white/60">
              Verified Customers
            </span>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-sheen p-8 md:p-10 reveal flex flex-col gap-6"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <Quote className="w-7 h-7 text-[#D4AF37]/70" strokeWidth={1.4} />
              <blockquote className="font-serif-display text-xl md:text-2xl leading-[1.45] text-white/90 italic">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-6 border-t border-[#262626] flex items-center justify-between">
                <figcaption className="text-[11px] tracking-[0.28em] uppercase text-white/60">
                  — {t.author}
                </figcaption>
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star
                      key={k}
                      className="w-3 h-3 text-[#D4AF37]"
                      fill="#D4AF37"
                    />
                  ))}
                </div>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
